// extracted by mini-css-extract-plugin
module.exports = {"ptitle":"WelcomeName_ptitle__3wu0B","white":"WelcomeName_white__4AVkc"};